<template>
    <div>
        <h1 class="subtitle">Clientes</h1>
        <div class="nj-cols">
            <div class="nj-card">
                <div class="nj-cols">
                    <div>
                        <div class="nj-label">Cliente</div>
                        <input type="text" class="nj-text" v-model="filters.cli_search" placeholder="DNI - Cliente / RUC - Razón Social" @keyup.enter="buscar()">
                    </div>
                </div>
                <Buttons line>
                    <button class="nj-button" @click="buscar()">Buscar</button>
                    <button class="nj-button c-green" @click="popup({ componente: 'registrar', abrir: true })">Nuevo</button>
                </Buttons>
            </div>
            <div class="nj-card">
                <b-table :data="clientes" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition" :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" aria-next-label="Next page"
                    aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                    <template slot-scope="props">
                        <b-table-column label="Documento" header-class="is-info">{{ props.row.cli_tipo_documento_identidad_nombre }} {{ props.row.cli_documento_identidad }}</b-table-column>
                        <b-table-column label="Cliente" header-class="is-info">{{ props.row.cli_nombre }}</b-table-column>
                        <b-table-column label="Telefono / Celular" header-class="is-info">{{ props.row.cli_telefono }}</b-table-column>
                        <b-table-column label="Estado" header-class="is-info">
                            <b-field>
                                <b-tag :class="tagEstado(props.row.cli_estado)">{{ props.row.cli_estado_nombre }}</b-tag>
                            </b-field>
                        </b-table-column>
                        <b-table-column label="Opciones" header-class="is-info">
                            <div class="nj-flx">
                                <button class="nj-button icon c-blue" @click="popup({ componente: 'ver', abrir: true, cli_id: props.row.cli_id })" title="Ver"><i class="mdi-information"></i></button>
                                <button class="nj-button icon" @click="popup({ componente: 'modificar', abrir: true, cli_id: props.row.cli_id })" title="Modificar"><i class="mdi-pencil"></i></button>
                            </div>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
        <!-- popups -->
        <RegistrarCliente v-if="activarRegistrar" @close="popup($event)" :lista_tipo_documento_identidad="lista_tipo_documento_identidad" />
        <VerCliente v-if="activarVer" @close="popup($event)" :cli_id="cli_id" />
        <ModificarCliente v-if="activarModificar" @close="popup($event)" :lista_tipo_documento_identidad="lista_tipo_documento_identidad" :cli_id="cli_id" />
    </div>
</template>

<script>
import Toast from "../../util/toast"
import Keyboard from "../../util/keyboard"
import { Buttons } from "./../components"
import RegistrarCliente from "../../modules/cliente/RegistrarCliente"
import VerCliente from "../../modules/cliente/VerCliente"
import ModificarCliente from "../../modules/cliente/ModificarCliente"
import { AppService, ClienteService, ResponseStatus } from "../../services"

export default {
    name: "Cliente",
    components: {
        RegistrarCliente,
        VerCliente,
        ModificarCliente,
        Buttons,
    },
    data() {
        return {
            filters: {
                cli_search: null
            },
            lista_tipo_documento_identidad: [],
            clientes: [],
            estados: [],
            activarRegistrar: false,
            activarModificar: false,
            activarVer: false,
            cli_id: null,
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
        }
    },
    methods: {
        buscar() {
            ClienteService.buscar({
                cliente: this.filters
            }).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.clientes = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        popup({ componente, abrir, buscar = false, cli_id = null }) {
            this.cli_id = cli_id
            switch (componente) {
                case "registrar":
                    // registrar 
                    this.activarRegistrar = abrir
                    break
                case "ver":
                    // ver
                    this.activarVer = abrir
                    break
                case "modificar":
                    // modificar
                    this.activarModificar = abrir
                    break
                case "all":
                    // cerrar todo
                    this.activarRegistrar = false
                    this.activarVer = false
                    this.activarModificar = false
                    break
            }
            if (buscar) {
                this.buscar()
            }
        },
        tagEstado(id) {
            return this.estados.find((item) => item.est_id == id).styles
        }
    },
    mounted() {
        AppService
            .getData(["tipos_documento_identidad", "estados"])
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    if (ResponseStatus.isSuccess(response)) {
                        this.lista_tipo_documento_identidad = response.data.tipos_documento_identidad
                        this.estados = response.data.estados
                        this.buscar()
                    }
                    else {
                        Toast.error(response.message)
                    }
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
                console.error(`error: `, error)
            })
    }
}
</script>

<style scoped></style>